import * as pdfjs from 'pdfjs-dist';
import JSZip from 'jszip';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

export async function parseFile(file) {
  const ext = file.name.split('.').pop().toLowerCase();
  if (ext === 'txt') return parseTxt(file);
  if (ext === 'pdf') return parsePdf(file);
  if (ext === 'epub') return parseEpub(file);
  throw new Error('Unsupported file type. Please use TXT, PDF, or EPUB.');
}

function parseTxt(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = e => resolve(e.target.result);
    reader.onerror = reject;
    reader.readAsText(file, 'UTF-8');
  });
}

async function parsePdf(file) {
  const buffer = await file.arrayBuffer();
  const pdf = await pdfjs.getDocument({ data: buffer }).promise;
  let text = '';
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const content = await page.getTextContent();
    text += content.items.map(item => item.str).join('') + '\n';
  }
  return text;
}

async function parseEpub(file) {
  const zip = await JSZip.loadAsync(file);

  const containerXml = await zip.file('META-INF/container.xml')?.async('text');
  if (!containerXml) throw new Error('Invalid EPUB: missing container.xml');

  const parser = new DOMParser();
  const containerDoc = parser.parseFromString(containerXml, 'application/xml');
  const rootfilePath = containerDoc.querySelector('rootfile')?.getAttribute('full-path');
  if (!rootfilePath) throw new Error('Invalid EPUB: missing rootfile path');

  const opfContent = await zip.file(rootfilePath)?.async('text');
  if (!opfContent) throw new Error('Invalid EPUB: missing OPF file');

  const opfDoc = parser.parseFromString(opfContent, 'application/xml');
  const base = rootfilePath.includes('/')
    ? rootfilePath.substring(0, rootfilePath.lastIndexOf('/') + 1)
    : '';

  const manifest = {};
  opfDoc.querySelectorAll('manifest item').forEach(item => {
    manifest[item.getAttribute('id')] = item.getAttribute('href');
  });

  let text = '';
  for (const itemref of opfDoc.querySelectorAll('spine itemref')) {
    const href = manifest[itemref.getAttribute('idref')];
    if (!href) continue;
    const content = await zip.file(base + href)?.async('text');
    if (!content) continue;
    const doc = parser.parseFromString(content, 'application/xhtml+xml');
    text += (doc.body?.textContent || '') + '\n\n';
  }
  return text;
}
